import { CanActivateFn, Router } from '@angular/router';
import { AuthOpenIdService } from '../_Services/auth/auth-open-id-service';
import { inject } from '@angular/core';

export const authRedirectGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthOpenIdService);
  const router = inject(Router);

  // Wacht tot het token uit storage geladen is (belangrijk bij page refresh)
  await authService.waitUntilReady();

  // Als al ingelogd (token in storage), redirect naar dashboard
  if (authService.isLoggedIn()) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
